const config: Config = require('config.json');

export interface Config {
  apiBasePath: string;
  reportApiBasePath: string;
  authUri: string;
  billingApiBasePath: string;
  clientId: string;
  presentationApiBasePath: string;
  coreUrl: string;
  lossFactorApiBasePath: string;
  ratingCalculatorApiBasePath: string;
  telemetryCalculatorApiBasePath: string;
  showDiscountVariations: boolean;
  redirectUri: string;
  scope: string;
  telemetryApiBasePath: string;
  useAuth: boolean;
  useRefreshToken: boolean;
  environment: string;
  featureUser: string;
  featurehubUrl: string;
  featurehubClientKey: string;
  featurehubPollingInterval: number;
  client: string;
  metricsBasePath: string;
  metricsBasePathEnvoy?: string;
  lossFactorKey?: string;
  shareablePlans: boolean;
  showErrorDownload: boolean;
  showSystemErrors: boolean;
  dayLightSaving: boolean;
  marketOffset: string;
  marketTimezone: string;
  bestOfferProviderIds: string;
  bestOfferChangeoverDay: string;
  showUiElements: string;
  showRatingCalculatorMetrics: boolean;
  showErrorResponseBodyError: boolean;
  showCalculationCountOnConnectionScreen: boolean;
  reportsAvailable: string[];
  offMarketMeasurementPoints: boolean;
}

const getConfig = () => {
  return config;
};

export default getConfig;
